<template>
  <AppDatePicker
    v-model="date"
    class="without-label"
    :min-date="minDate"
    :start-week-on="startWeekOn"
    :start-date="date"
    :end-date="dateEnd"
    async
  />
</template>

<script>
import { mapGetters, mapState } from 'vuex';

export default {
  name: 'ReportDateFilter',
  computed: {
    ...mapState({
      dateEnd: (state) => {
        return TimeUtils.parse_internal_date(state.report_query.date_end);
      },
    }),
    ...mapGetters(['minDate', 'startWeekOn']),
    date: {
      get() {
        return TimeUtils.parse_internal_date(this.$store.state.report_query.date);
      },
      set(date) {
        date = TimeUtils.parse_internal_date(date);

        const startDay = toMomentIsoWeekday(this.startWeekOn);
        const startDate = TimeUtils.format_internal_date(date.startOfIsoWeek(startDay));
        const endDate = TimeUtils.format_internal_date(date.endOfIsoWeek(startDay));

        this.$store.dispatch('updateSearch', {
          date: startDate,
          date_end: endDate,
        });
      },
    },
  },
};
</script>
